import { render } from "./Deliveries-page.vue?vue&type=template&id=94163ec6&scoped=true"
import script from "./Deliveries-page.vue?vue&type=script&lang=js"
export * from "./Deliveries-page.vue?vue&type=script&lang=js"

import "./Deliveries-page.vue?vue&type=style&index=0&id=94163ec6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94163ec6"]])

export default __exports__